const mutations = {
  updateAboutUs: (state, payload) => {
    state.aboutUs = payload
  },
  updateBenefits: (state, payload) => {
    state.benefits = { ...payload }
  },
  updateSlogan: (state, payload) => {
    state.slogan = payload
  },
  updateBanner: (state, payload) => {
    state.banner = payload
  },
  updateTeam: (state, payload) => {
    state.team = payload
  },
  updateKpi: (state, payload) => {
    state.kpi = payload
  },
  updateAllBenefits: (state, payload) => {
    state.allBenefits = payload
  },
  updateIsPublished: (state, payload) => {
    state.isPublished = payload
  },
  getSocials: (state, payload) => {
    state.socials = payload
  },
  createSocials: (state, payload) => {
    state.socials = payload
  },
  updateSocials: (state, payload) => {
	state.socials = payload
  },
  updateInside: (state, payload) => {
	state.inside = payload
  },
  updatePublicProfile: (state, payload) => {
	state.publicProfile = payload
  }
}

export default mutations
